import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const Banner = props => {
  return (
    <React.Fragment>
      {props.appLoaded && (
        <div className="banner">
          <div className="container">
            <Typography
              variant="h1"
              component="h2"
              style={{ textAlign: 'center' }}
            >
              Non Cash Deposit Portal
            </Typography>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

Banner.propTypes = {
  appLoaded: PropTypes.bool,
};

export default Banner;
